export const SET_BUSINESS_LISTINGS_DATA = 'SET_BUSINESS_LISTINGS_DATA';
export const DEALS_ALL = "ALL";
export const DEALS_UN_APPROVED = "DEALS_UN_APPROVED";
export const DEALS_PINEGRAY = "DEALS_PINEGRAY";
export const DEALS_OTHERS = "DEALS_OTHERS";
export const DEALS_DECLINED = "DEALS_DECLINED";
export const UPDATE_WIZARD_FORM_DATA = "UPDATE_WIZARD_FORM_DATA";
export const RESET_STARTUP_EQUITY_DATA = "RESET_STARTUP_EQUITY_DATA";
export const SET_STARTUP_EQUITY_DEAL_DATA = "SET_STARTUP_EQUITY_DEAL_DATA";